module.exports = {
  EMAIL: 1,
  GOOGLE: 2,
  BACKUP_CODE: 3,
};
